module.exports = __webpack_public_path__ + "static/media/vinnie.64434577.gif";